type PriorityMap = {
  [key: number]: string;
}

export const priorityMap: PriorityMap = {
  0: "priority0Row",
  1: "priority1Row",
  2: "priority2Row",
  3: "priority3Row",
}
